import React, { useEffect } from 'react'
import { useTranslate, required, BooleanInput } from 'react-admin'
import { Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Skeleton } from '@mui/material'
import { ChipInput } from 'src/components/uiElements/fields/ChipInput'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { useQuery } from 'react-query'
import { BILLING, LIQUIDATION } from 'src/components/pages/sales/business-rule/helper/const'
import { orderSuppliers } from '../../helper/sortSuppliersFunction.js'

export const GetAirFields = ({
  record,
  setLoadingAirSources,
  loadingAirAirlines,
  airAirlines,
  loadingAirSuppliers,
  airSuppliers,
  defaultValue = false,
  selectedRuleType,
}) => {
  const translate = useTranslate()
  const gds_options = [
    { value: 'all', name: 'Todas' },
    { value: 'AMS', name: 'Amadeus' },
    { value: 'SBR', name: 'Sabre' },
    { value: 'FBO', name: 'FlyBondi' },
    { value: 'NDC', name: 'NDC' },
    { value: 'NDX', name: 'NDX' }
  ]
  const source = useQuery('ext-air-source', businessRuleServices.getAirSources)
  useEffect(() => {
    setLoadingAirSources && setLoadingAirSources(source?.isLoading)
  }, [source?.isLoading])

  return (
    <Grid container spacing={3}>
      <EditInputsWrap label={translate('ra.field.airline')} md={6} lg={4} required>
        {loadingAirAirlines ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='air.airline_code'
            options={airAirlines}
            label=''
            optionsText={['long_name']}
            optionValue='short_name'
            size='small'
            multiple
            showAllOption
            showSearch
            validate={[required()]}
            defaultValue={defaultValue ? record?.air?.airline_code : undefined}
          />
        )}
      </EditInputsWrap>

      <EditInputsWrap label={translate('ra.field.source')} md={6} lg={3} required>
        {source?.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='air.source_relation'
            options={source?.data || []}
            label=''
            optionsText={['long_name']}
            size='small'
            multiple
            showSearch
            defaultValue={defaultValue ? record?.air?.source_relation : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>

      <EditInputsWrap
        label={translate('ra.field.route')}
        md={12}
        lg={5}
        required
        tooltiptext={translate('ra.message.format_route')}
      >
        <ChipInput
          source='air.route'
          defaultValue={defaultValue ? record?.air?.route : undefined}
          showAllOption
          validate={[required()]}
          helperText={translate('ra.message.all_route')}
          routeValidation={true}
        />
      </EditInputsWrap>

      <EditInputsWrap label={translate('ra.field.supplier')} md={6} lg={4} required>
        {loadingAirSuppliers ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='air.supplier'
            options={orderSuppliers(airSuppliers, record?.air?.supplier?.include ?? [])}
            label=''
            optionsText={['name']}
            optionValue='code'
            size='small'
            multiple
            showAllOption
            showSearch
            validate={[required()]}
            defaultValue={defaultValue ? record?.air?.supplier : undefined}
          />
        )}
      </EditInputsWrap>
      {
        selectedRuleType === BILLING &&
        <EditInputsWrap label={translate('ra.field.is_emd')} required>
          <BooleanInput label={translate('ra.field.is_emd')} source='air.is_emd' fullWidth />
        </EditInputsWrap>
      }

      {(selectedRuleType === BILLING || selectedRuleType === LIQUIDATION) && <EditInputsWrap label={'GDS'} md={6} lg={3} required>
        {source?.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='air.gds'
            options={gds_options}
            label=''
            optionsText={['name']}
            optionValue='value'
            size='small'
            multiple
            showSearch
            defaultValue={record?.air?.gds ? record?.air?.gds : ['all']}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>}

    </Grid>
  )
}
